import { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import slugify from 'dibs-slugify/exports/slugify';
import { sessionStorage } from 'dibs-browser-storage';
import { trackFilterClick } from '../../utils/tracking/searchBrowse/filterTracking';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { Link } from 'dibs-elements/exports/Link';

// components
import { ExpandingArea } from 'dibs-elements/exports/ExpandingArea';
import { RotatingArrow } from 'dibs-elements/exports/RotatingArrow';

// styles
import styles from './buyRefineMenuFacet.scss';

export const SESSION_STORAGE_KEY = 'facetMenu';

function updateLocalStorage({ isExpanded, storageFacetKey }) {
    const sessionFacetMenu = sessionStorage.getItem(SESSION_STORAGE_KEY) || {};
    sessionStorage.setItem(
        SESSION_STORAGE_KEY,
        Object.assign(sessionFacetMenu, { [storageFacetKey]: isExpanded })
    );
}
export function BuyMobileNavRefineMenuFacet({
    title,
    children,
    appliedFiltersComponent,
    storageFacetKey,
    initiallyExpanded,
}) {
    const [isExpanded, setIsExpanded] = useState(initiallyExpanded);
    const { isSbTopNavVariant: shouldIgnoreLocalStorageState } = useContext(ServerVarsContext);
    useEffect(() => {
        const sessionFacetMenu = sessionStorage.getItem(SESSION_STORAGE_KEY) || {};
        const isOpen = sessionFacetMenu[storageFacetKey];
        if (isOpen !== undefined && isExpanded !== isOpen && !shouldIgnoreLocalStorageState) {
            setIsExpanded(isOpen);
        }
    }, [storageFacetKey, isExpanded, shouldIgnoreLocalStorageState]);
    const onLabelClick = useCallback(() => {
        const newExpandedValue = !isExpanded;
        setIsExpanded(newExpandedValue);
        trackFilterClick(title, isExpanded);
        if (!shouldIgnoreLocalStorageState) {
            updateLocalStorage({ storageFacetKey, isExpanded: newExpandedValue });
        }
    }, [isExpanded, storageFacetKey, title, shouldIgnoreLocalStorageState]);

    return (
        <div className={styles.facetContainer}>
            <Link
                dataTn={`facet-${slugify(title)}-expanding-area`}
                className={styles.labelWrapper}
                onClick={onLabelClick}
            >
                <div className={styles.titleWrapper}>
                    <div className={styles.title}>{title}</div>
                    {appliedFiltersComponent}
                </div>
                <RotatingArrow direction={isExpanded ? 'up' : 'down'} />
            </Link>
            <ExpandingArea expanded={isExpanded} wrapperClass={styles.container}>
                <div className={styles.facetContent} data-tn={`facet-container-${slugify(title)}`}>
                    {children}
                </div>
            </ExpandingArea>
        </div>
    );
}

BuyMobileNavRefineMenuFacet.defaultProps = {
    initiallyExpanded: true,
};

BuyMobileNavRefineMenuFacet.propTypes = {
    initiallyExpanded: PropTypes.bool,
    title: PropTypes.string.isRequired,
    appliedFiltersComponent: PropTypes.node,
    children: PropTypes.node,
    storageFacetKey: PropTypes.string.isRequired,
};
